import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { GeneralService } from './general.service';
import { PersistenceService } from 'angular-persistence';
import { environment } from '../../environments/environment';
import { MessageService } from 'primeng/components/common/messageservice';
import { IncidentsFilter } from '../models/incidentsFilter.model';
import { IncidentHistory, ResponseModel } from '../models';

@Injectable()
export class IncidentsService extends GeneralService {
  constructor(protected messageService: MessageService, protected httpClient: HttpClient, protected persistenceService: PersistenceService) {
    super(messageService, httpClient, persistenceService, environment.apiPostUrl, "Incidents");
  }

  async getListShipmentBoxByShipmentNumberS(shipmentNumberS: any,pageNumber:any,pageSize:any): Promise<any> {
    let params = new HttpParams();
    params = params.append("shipmentNumberS", shipmentNumberS);
    params = params.append("pageNumber", pageNumber);
    params = params.append("pageSize", pageSize);
    const res = await super.getCustomApi("GetListShipmentBoxByShipmentNumberS", params).toPromise();
    if(!this.isValidResponse(res)) return;
    return res.data;
  }

  async getListIncident(model:any): Promise<ResponseModel> {
    const res = await super.postCustomApi("GetListIncident", model).toPromise();
    return res;
  }

  async getIncidentDetail(incidentId:any): Promise<any> {
    let params = new HttpParams();
    params = params.append("incidentId",incidentId);
    const res = await super.getCustomApi("GetIncidentDetail", params).toPromise();
    if(!this.isValidResponse(res)) return;
    return res.data;
  }

  async updateSatatus(model:any): Promise<any> {
    const res = await super.postCustomApi("UpdateStatusIncident", model).toPromise();
    if(!this.isValidResponse(res)) return;
    return res.data;
  }

  async getIncidentImageByShipment(shipmentId:any): Promise<any> {
    let params = new HttpParams;
    params = params.append('shipmentId',shipmentId)
    const res = await super.getCustomApi("GetIncidentImageByShipment", params).toPromise();
    if(!this.isValidResponse(res)) return;
    return res.data;
  }

  async getListIncidentHistory(incidentId:any):Promise<IncidentHistory[]>{
    let params = new HttpParams;
    params = params.append('incidentId',incidentId)
    const res = await super.getCustomApi("GetListIncidentHistory", params).toPromise();
    if(!this.isValidResponse(res)) return;
    return res.data;
  }
}
